'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tooltip = require('../../src/styles/tooltip.scss');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _svgIcon = require('../../../svg-icon');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = function (_Component) {
  (0, _inherits3.default)(Tooltip, _Component);

  function Tooltip(props) {
    (0, _classCallCheck3.default)(this, Tooltip);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.state = {
      isTextVisible: false
    };

    _this.tooltipClickHandler = _this.tooltipClickHandler.bind(_this);
    return _this;
  }

  Tooltip.prototype.tooltipClickHandler = function tooltipClickHandler(event) {
    if (event.target === this.tooltipIcon) {
      this.setState({
        isTextVisible: !this.state.isTextVisible
      });
    } else if (event.target !== this.tooltipContent) {
      this.setState({
        isTextVisible: false
      });
    }
  };

  Tooltip.prototype.componentDidMount = function componentDidMount() {
    if (!(0, _doctifyUtils.isServerSide)()) {
      document.body.addEventListener('click', this.tooltipClickHandler);
    }
  };

  Tooltip.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!(0, _doctifyUtils.isServerSide)()) {
      document.body.removeEventListener('click', this.tooltipClickHandler);
    }
  };

  Tooltip.prototype.render = function render() {
    var _this2 = this;

    var isTextVisible = this.state.isTextVisible;


    return _react2.default.createElement(
      'div',
      { className: _tooltip2.default['tooltip'] },
      _react2.default.createElement(
        'span',
        { className: _tooltip2.default['tooltip__icon-wrapper'], ref: function ref(elem) {
            _this2.tooltipIcon = elem;
          } },
        _react2.default.createElement(_svgIcon.SvgIcon, {
          icon: 'info',
          className: _tooltip2.default['tooltip__icon']
        })
      ),
      _react2.default.createElement(
        'div',
        { className: _tooltip2.default['tooltip__content'], style: { visibility: isTextVisible ? 'visible' : 'hidden' }, ref: function ref(elem) {
            _this2.tooltipContent = elem;
          } },
        this.props.children
      )
    );
  };

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;


// WEBPACK FOOTER //
// ./components/tooltip/lib/components/tooltip.js